/** Delete some or all assets for a KB article. */
export const kbArticleAssetsDeleteSpec = {
    uri: '/kb/article/[article]/assets',
    method: 'DELETE',
    adminOnly: true,
};
